module.exports = __webpack_public_path__ + "img/the-netherlands-diseases-of-the-nervous-system-male.69ef2201.png";